// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Products_SalvarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response for /so/products/salvar — returns the created/updated product ID.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Products_SalvarResponseDados {
so_product_id: number
}

export type Products_SalvarResponse = ApiResponse<Products_SalvarResponseDados>;

registerResponseContract('Products_SalvarResponse', {
  so_product_id: { type: 'number',  required: true },
})
